import getApiClient from '../../../../plugins/api'

export default {
    setSearchStatus: function(status) {
        this.searchParams['reservationStatus.id'] = status
    },
    changePage: function(page) {
        this.page = page
    },
    checkAccess: function() {
        const requestRole = 'ROLE_AGENCY',
            self = this

        let userRole = ''

        if (self.$store.state.user.roles) {
            userRole = self.$store.state.user.roles[0]
        }

        if (userRole !== requestRole) {
            // self.$router.push('/')
        }
    },

    loadReservations: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        self.searchParams.page = self.page

        self.searchParams['trip.startTime[after]'] = null
        self.searchParams['trip.startTime[before]'] = null

        if (self.searchParams.futureTrips) {
            self.searchParams['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.searchParams['trip.startTime[before]'] = new Date()
        }

        api.get('reservations', {
            params: self.searchParams
        })
            .then((result) => {
                self.reservations = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    loadAvailableStatuses: function () {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get('reservation_statuses')
            .then(result => {
                let data = result.data['hydra:member']

                data.forEach(item => {
                    self.availableStatus.push({
                        label: item.name,
                        value: item.id
                    })
                })
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    setPlace: function(data) {
        this.searchParams['trip.place.id'] = data.value
    },

    resetPlace: function() {
        this.searchParams['place.id'] = null
    },

    updateStatus: function(item) {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.patch(`/reservations/${item.id}`, {
            status: item.status.toString(),
            reservationStatus: `/reservation_statuses/${item.status}`
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.loadReservations()
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
